module.exports = __webpack_public_path__ + "static/media/eth-diamond-plain.svg.4ea2eab8.png";